import React, { useEffect, useState } from "react";
import { AdhocAgreementsErrorBanner } from "../../adhoc-agreements/ErrorBanner";
import { Grid } from "@material-ui/core";
import PageHeader from "../../shared/Header";
import { AdhocProjectsContent } from "./Content";

export const AdhocProjectsPage: React.FC = () => {
  const [error, setError] = useState("");
  const [bannerIsVisible, setBannerIsVisible] = useState(error.length > 0);
  console.log("error", error);
  console.log("bannerIsVisible", bannerIsVisible);

  const handleError = (error: string) => {
    setError(error);
    setBannerIsVisible(true);
  };

  const handleSuccess = () => {
    setError("");
    setBannerIsVisible(false);
  };

  return (
    <div>
      <AdhocAgreementsErrorBanner
        handleBannerDismiss={() => setBannerIsVisible(false)}
        error={error}
        showBanner={bannerIsVisible}
      />
      <Grid container>
        <PageHeader title="Adhoc Projects" />
        <AdhocProjectsContent onError={handleError} onSuccess={handleSuccess} />
      </Grid>
    </div>
  );
};

export default AdhocProjectsPage;
